import { render, staticRenderFns } from "./confirmPavilionAppointInfo.vue?vue&type=template&id=a6c23d8c&scoped=true"
import script from "./confirmPavilionAppointInfo.vue?vue&type=script&lang=js"
export * from "./confirmPavilionAppointInfo.vue?vue&type=script&lang=js"
import style0 from "./confirmPavilionAppointInfo.vue?vue&type=style&index=0&id=a6c23d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c23d8c",
  null
  
)

export default component.exports